module.exports = __webpack_public_path__ + "static/img/poster.33057b52.png";